const lineBreakBefore = (sentence, wordToBreak) => {
  const index = sentence.indexOf(wordToBreak);
  return `${sentence.substr(0, index)}<br />${sentence.substr(index)}`;
};

export default lineBreakBefore;
